import iconClose from 'assets/images/homeNew/exit.png'
import { Modal } from 'react-bootstrap'

function NotificationNew({ show, title, content, handleCancel, footer, className }) {
	return (
		<Modal
			show={show}
			onHide={handleCancel}
			centered
			className={`notification ${className || ''}`}
		>
			<img src={iconClose} alt="icon-close" className='icon-close' onClick={handleCancel} />
			{ 
        title && (
          <Modal.Header className='notification-head'>
				    {title}
			    </Modal.Header>
        )
      }
			{
        content && (
          <Modal.Body className='notification-content'>
				    {content}
			    </Modal.Body>
        )
      }
			{
        footer && (
          <Modal.Footer >
            <div className='notification-footer'>
              {footer}
            </div>
			    </Modal.Footer>
        )
      }
		</Modal>
	)
}

export default NotificationNew
